export const USER_LOGOUT = 'USER_LOGOUT'

export function userLogout() {
  return {
    type: USER_LOGOUT
  }
}
